<template>
  <div>
    <b-breadcrumb :items="crumb_links"></b-breadcrumb>
    <div class="flex text-left p-2">
      <h1 class="header">Accessibility</h1>
      <p>
        The Arabidopsis Information Resource and Phoenix Bioinformatics are
        committed to ensuring digital accessibility for all users. We strive to
        continually improve the user experience for everyone and apply relevant
        accessibility standards to ensure our platform is usable and inclusive.
      </p>

      <h2 class="section-header">Accessibility Standards and Conformance</h2>
      <p>
        TAIR's most recent accessibility audit was completed on November 25,
        2025 by the external firm,
        <a
          href="https://www.tpgi.com/"
          target="_blank"
          rel="noopener noreferrer"
          >TPGi</a
        >.
      </p>
      <p>
        To learn more about the current accessibility status of our platform,
        please view our
        <a
          href="/Arabidopsis Information Resource Accessibility Conformance Report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          >Accessibility Conformance Report</a
        >
        that is based on VPAT (Voluntary Product Accessibility Template) version
        2.5.
      </p>
      <p>
        This report covers the degree of conformance for the following
        accessibility standards/guidelines:
      </p>
      <ul class="standards-list">
        <li>Web Content Accessibility Guidelines (WCAG) 2.0 Level A and AA</li>
        <li>Web Content Accessibility Guidelines (WCAG) 2.1 Level A and AA</li>
        <li>Web Content Accessibility Guidelines (WCAG) 2.2 Level A and AA</li>
      </ul>

      <h2 class="section-header">Remediation Plan</h2>
      <p>
        Phoenix Bioinformatics has prepared a remediation plan to address the
        criteria marked "Partially Supports" in the conformance report. The plan
        organizes the work into three phases and targets completion by April 26,
        2027, in line with the U.S. Department of Justice Title II Interim Final
        Rule.
      </p>
      <p>
        <a
          href="/TAIR-Accessibility-Remediation-Plan.pdf"
          target="_blank"
          rel="noopener noreferrer"
          >TAIR Accessibility Remediation Plan (PDF)</a
        >
      </p>

      <h2 class="section-header">
        Need Help or Encountering Accessibility Issues?
      </h2>
      <p>
        If you experience any difficulty accessing content or features on our
        site, or if you have suggestions for improving accessibility, please
        contact us by email at
        <a href="mailto:info@phoenixbioinformatics.org"
          >info@phoenixbioinformatics.org</a
        >. We welcome your feedback.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accessibility",
  data() {
    return {
      crumb_links: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Accessibility",
          active: true,
        },
      ],
    };
  },
  mounted() {
    document.title = "Accessibility - TAIR";
  },
};
</script>

<style scoped lang="scss">
.header {
  color: #0c335d;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: bold;
}

.section-header {
  color: #0c335d;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
}

.flex {
  max-width: 1200px;
  margin: 0 auto;
}

p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

a {
  color: #0c335d;
  text-decoration: underline;
  &:hover {
    color: #0a2a4a;
  }
}

.standards-list {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
  li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
  }
}

.breadcrumb {
  padding: 10px 0 10px 1rem;
  font-weight: bold;
  font-size: 18px;
}
</style>
